module.exports = __webpack_public_path__ + "static/media/blogBackground.1f13b543.jpg";